/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var TimeLineProps = {
  labelAlign: {
    type: String,
    "default": "left",
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "right", "alternate", "top", "bottom"].includes(val);
    }
  },
  layout: {
    type: String,
    "default": "vertical",
    validator: function validator(val) {
      if (!val) return true;
      return ["horizontal", "vertical"].includes(val);
    }
  },
  mode: {
    type: String,
    "default": "alternate",
    validator: function validator(val) {
      if (!val) return true;
      return ["alternate", "same"].includes(val);
    }
  },
  reverse: Boolean,
  theme: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "dot"].includes(val);
    }
  }
};

export { TimeLineProps as default };
//# sourceMappingURL=props.mjs.map
